module.exports = __webpack_public_path__ + "ptc_nakagawa_H2.4528c319.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/nakagawa/parent_to_child/ptc_nakagawa_H2.jpg
// module id = 5yHK
// module chunks = 0